export default __webpack_public_path__ + "static/media/profile.be5a6149.svg";